import _orderBy from 'lodash/orderBy';

import { getPromoEntriesList } from 'api/ugc';
import {
    searchTabType,
    apiSearchTypes,
    apiSortingTypes,
    apiOrderTypes,
    setNoSearchItems,
    ALL_TASK_UUID
} from 'client/redux/modules/flagsUgc';
import { SortTypeMapping } from 'ugc/components/workPage/SettingPreviews/defaultGameSetting';

const UPDATE_COLLECTIONS = 'ugcCollections/UPDATE_COLLECTIONS';
const CLEAR_COLLECTIONS = 'ugcCollections/CLEAR_COLLECTIONS';
const UPDATE_COLLECTIONS_LOCAL_VOTE = 'ugcCollections/UPDATE_COLLECTIONS_LOCAL_VOTE';

const defaultState = {
    isFetching: false,
    collections: [],
    page: 1,
    perItems: 20,
    totalPage: 1
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_COLLECTIONS:
            return { ...state, ...action.payload };
        case CLEAR_COLLECTIONS: {
            return { ...state, collections: [], totalPage: 0 };
        }
        case UPDATE_COLLECTIONS_LOCAL_VOTE: {
            const { mediaEntryId } = action.payload;
            return {
                ...state,
                collections: state.collections.map(c =>
                    c.id === mediaEntryId ? { ...c, mediaLibraryVote: c.mediaLibraryVote + 1 } : c
                )
            };
        }
        default:
            return state;
    }
};

export default reducer;

function setIsFetchingUgc(status) {
    return {
        type: UPDATE_COLLECTIONS,
        payload: {
            isFetching: status
        }
    };
}

export function getUgcCollection({ page, perItems, setIsFetching = true } = {}) {
    return async (dispatch, getState) => {
        try {
            if (setIsFetching) {
                dispatch(setIsFetchingUgc(true));
            }
            const {
                promo: { uuid: promoUUID },
                flagsUgc: { searchKeyword, sortingType, searchType, taskUUID },
                ugcCollections: { page: currentPage, perItems: currentPerItems }
            } = getState();
            const p = page ?? currentPage;
            const i = perItems ?? currentPerItems;
            const query = (() => {
                let q = {
                    page: p,
                    perPage: i
                };
                if (sortingType === searchTabType) {
                    q.search = searchKeyword;
                    q.searchColumn = apiSearchTypes[searchType];
                } else {
                    q.orderColumn = apiSortingTypes[sortingType];
                    q.order = apiOrderTypes[sortingType];
                }
                q.taskUuid = taskUUID === ALL_TASK_UUID ? undefined : taskUUID;
                return q;
            })();
            const {
                payload: { items = [], itemSum }
            } = await getPromoEntriesList(promoUUID, query);

            if (items.length === 0 && Boolean(searchKeyword)) {
                dispatch(setNoSearchItems(true));
            } else {
                dispatch(setNoSearchItems(false));
                dispatch({
                    type: UPDATE_COLLECTIONS,
                    payload: {
                        collections: sortUgcMedia(sortingType, convertMediaDatas(items)),
                        page: p,
                        perItems: i,
                        totalPage: Math.ceil(itemSum / i),
                        count: itemSum
                    }
                });
            }
        } finally {
            if (setIsFetching) {
                dispatch(setIsFetchingUgc(false));
            }
        }
    };
}

function convertMediaDatas(items = []) {
    return items.map(i => {
        let newI = { ...i };
        if (typeof newI.mediaLibraryRank === 'string') {
            newI.mediaLibraryRank = Number(newI.mediaLibraryRank);
        }
        if (typeof newI.mediaLibraryVote === 'string') {
            newI.mediaLibraryVote = Number(newI.mediaLibraryVote);
        }
        return newI;
    });
}
function sortUgcMedia(sortingType, items = []) {
    const isBackEndRecalculatingRank = items.every(
        i => i.mediaLibraryVote === null && i.mediaLibraryRank === null
    );
    return !isBackEndRecalculatingRank && sortingType === SortTypeMapping.RANKING
        ? _orderBy(items, ['mediaLibraryVote', 'mediaLibraryRank'], ['desc', 'asc'])
        : items;
}

export function clearCollection() {
    return {
        type: CLEAR_COLLECTIONS
    };
}

export function updateLocationLocalVote(mediaEntryId) {
    return {
        type: UPDATE_COLLECTIONS_LOCAL_VOTE,
        payload: {
            mediaEntryId
        }
    };
}
